import { useQuery, useQueryClient } from 'react-query';
import { getAccountFileBatches, saveFileBatch, deleteFileBatch } from '@sp-firebase/fileBatchesFB';
import { IFileBatch } from '../sp-types';

const FILE_BATCHES = 'fileBatches';
export const useFileBatches = (accountId?: string) => {
  const queryClient = useQueryClient();

  const {
    data: batches,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: [FILE_BATCHES, accountId],
    queryFn: () => getAccountFileBatches(accountId!),
    enabled: !!accountId,
    select: (batches?: IFileBatch[]) => batches?.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds),
  });

  const saveBatch = async (fileBatchData: any) => {
    if (!accountId) return;

    await saveFileBatch(fileBatchData);
    await queryClient.invalidateQueries({ queryKey: [FILE_BATCHES, accountId] });
    refetch();
  };

  const deleteBatch = async (batchId: string) => {
    if (!accountId) return;
    await deleteFileBatch(accountId, batchId);
    await queryClient.invalidateQueries({ queryKey: [FILE_BATCHES, accountId] });
    refetch();
  };

  return {
    batches,
    isLoading,
    error,
    refetch,
    saveBatch,
    deleteBatch,
  };
};
